module.exports = __webpack_public_path__ + "static/img/8.329bcae.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/3/sp/8.png
// module id = HKM0
// module chunks = 0